/* eslint-disable camelcase */
import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'src/api/axiosBaseQuery'
import { API_BASE_PATH } from 'src/utils/constants'
import {
  PaginationPayload,
  ParentGymDetailsResponse,
  ParentGymsListResponse,
  UpdateParentGymPayload,
} from './types'

const API_ENDPOINT = '/api/v1/fitness'

const manageParentGymsApi = createApi({
  reducerPath: 'manageParentGymsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_PATH,
  }),
  tagTypes: ['manageParentGymsApi'],
  endpoints: (builder) => ({
    getParentGymsList: builder.query<ParentGymsListResponse, PaginationPayload>({
      query: ({ page = 1, pageSize = 10, sortBy = '', search = '' }) => ({
        url: `${API_ENDPOINT}/admin_parent_gyms/?q=${search}&page=${page}&page_size=${pageSize}${
          sortBy ? `&sort_by=${sortBy}` : ''
        }`,
        method: 'GET',
      }),
      transformResponse: (response: ParentGymsListResponse) => {
        return response
      },
    }),

    getParentGymById: builder.query<ParentGymDetailsResponse, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_parent_gym/${id}/`,
        method: 'GET',
      }),
      transformResponse: (response: ParentGymDetailsResponse) => {
        return response
      },
    }),

    addParentGym: builder.mutation<void, FormData>({
      query: (data) => ({
        url: `${API_ENDPOINT}/admin_parent_gym/`,
        method: 'POST',
        data: data,
      }),
    }),

    deleteParentGym: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_ENDPOINT}/admin_parent_gym/${id}/`,
        method: 'DELETE',
      }),
    }),

    updateParentGym: builder.mutation<void, UpdateParentGymPayload>({
      query: ({ data, id }) => ({
        url: `${API_ENDPOINT}/admin_parent_gym/${id}/`,
        method: 'PATCH',
        data: data,
      }),
    }),
  }),
})

export const {
  useGetParentGymsListQuery,
  useAddParentGymMutation,
  useDeleteParentGymMutation,
  useGetParentGymByIdQuery,
  useUpdateParentGymMutation,
  useLazyGetParentGymsListQuery
} = manageParentGymsApi
export default manageParentGymsApi
